// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"664":"core_home","987":"popularize_pay"}[chunkId] || chunkId) + "." + {"198":"00848aab","265":"ab9b1e41","640":"ae1c89fb","652":"19435b52","664":"e9009da6","987":"9f115997"}[chunkId] + ".js";
};